<div id="backup" class="tab-pane fade active in">
    <div style="width:48%;float:left;">
        <h3 class="heading4">Download backup files</h3>
        <br>
        <table class="table table-bordered table-hover">
            <thead>
                <colgroup>
                    <col width="25%">
                    <col width="25%">
                    <col width="25%">
                    <col width="25%">
                </colgroup>
            </thead>
            <tbody>
                <tr style="background-color:#F9f9f9;">
                    <th>
                        <div class="center"><b>Files</b></div >
                    </th>
                    <th>
                        <div class="center"><b>Download</b></div >
                    </th>

                </tr>
            
            </tbody>
            <tbody style="text-align:center;">
                <tr>
                    <td>
                        Tax Code Mapping Sheet
                    </td>
                    <td>
                        <a *ngIf="result.tax == 'success'" (click)="fileDownload(DownloadTax)" download="">
                            <i class="fa fa-download" aria-hidden="true" style="color:green;"></i>
                        </a>
                        <i *ngIf="result.tax == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                    </td>
                </tr>
                

                <tr>
                    <td>
                        Consolidated Excel File (train.xlsx)
                    </td>

                    <td>
                        <a *ngIf="result.train == 'success'" (click)="fileDownload(DownloadXL)" download="">
                            <i class="fa fa-download" aria-hidden="true" style="color:green;"></i>
                        </a>

                        <i *ngIf="result.train == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                    </td>
                </tr>
                <tr>
                    <td>
                        Model Files
                    </td>

                    <td>
                    
                        <a *ngIf="result.model == 'success'" (click)="fileDownload(DownloadModel)" download="">
                            <i class="fa fa-download" aria-hidden="true" style="color:green;"></i>
                        </a>

                        <i *ngIf="result.model == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                    </td>
                </tr>
                <tr>
                    <td>
                        Predicted Excel File
                    </td>

                    <td>
                        <a *ngIf="result.predict == 'success'" (click)="fileDownload(DownloadPredict)" download="">
                            <i class="fa fa-download" aria-hidden="true" style="color:green;"></i>
                        </a>
                        
                        <i *ngIf="result.predict == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                    </td>
                </tr>


            </tbody>
        </table>
        <br>
       
    </div>

    <div style="width:50%;float:right;border-left: #eee solid 2px; min-height:600px;padding-left:30px;">

        <h3 class="heading4">Status</h3>

            <p class="alert alert-danger" id="successMessage" *ngIf= "result.BackupError != null">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{result.BackupError}}
            </p>            
 
        <br>
        <table class="table table-bordered table-hover">
            <thead>
                <colgroup><col width="25%">
                <col width="25%">
                <col width="25%">
                <col width="25%">

                </colgroup>
            </thead>
            <tbody>
                <tr style="background-color:#F9f9f9;">
                    <th>
                        <div class="center"><b>Title</b></div >
                    </th>
                    <th>
                        <div class="center"><b>Status/View</b></div >
                    </th>

                </tr>
        
            </tbody>
            
            <tbody style="text-align:center;">
                <tr>
                    <td>
                        Tax Code Mapping Sheet
                    </td>
                    <td>
                        <i *ngIf= "result.tax == 'success'" class="fa fa-check" aria-hidden="true" style="color:green;" ></i>

                        <i *ngIf= "result.tax == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                    
                    </td>

                </tr>
                <tr>
                    <td>
                        Excel Files
                    </td>
                    <td>
                         <!-- @if (TempData["BackupError"] != null) { } else { -->

                        <a (click)= "showExcelModal()" *ngIf="result.BackupError == null" class="modal-link" data-target="#modal-container" data-toggle="modal">
                            <span class="glyphicon glyphicon-eye-open" style="color:#666;"></span>
                        </a>
                    </td>
                </tr>

                <tr>
                    <td>
                        Consolidated Excel File (train.xlsx)
                    </td>

                    <td>

                        <i *ngIf= "result.train == 'success'" class="fa fa-check" aria-hidden="true" style="color:green;"></i>

                        <i *ngIf= "result.train == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                    
                    </td>
                </tr>
                <tr>
                    <td>
                        Model Files
                    </td>

                    <td>
                        <i *ngIf="result.model == 'success'" class="fa fa-check" aria-hidden="true" style="color:green;"></i>
                        
                        <i *ngIf="result.model == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                    
                    </td>
                </tr><tr>
                    <td>
                        Label Mapping
                    </td>
                    <td>
                         <!-- @if (TempData["labelMapping"] == "error") {
                        <i class="fa fa-remove" aria-hidden="true" style="color:red;"></i>
                        } 
                        else if (TempData["labelMapping"] == "success") { -->
                        <i *ngIf="result.labelMapping == 'error'" class="fa fa-remove" aria-hidden="true" style="color:red;"></i>

                        <a (click)= "showLabelModal()" *ngIf="result.labelMapping == 'success'"  class="modal-link">
                            <span class="glyphicon glyphicon-eye-open" style="color:#666;"></span>
                        </a>
                    </td>
                </tr>




            </tbody>
        </table>

        <br>
        <br>
        <a  style="color:#666;" (click)="fileInput.click()">
            <i class="fa fa-upload" aria-hidden="true" style="color:#666;"> &nbsp;  </i>
            
                <input #fileInput type="file" style="display:none" (change)="fileChange($event)" id="btnUpload"/>
            
            Upload Model File (if any)
        </a>
        
    </div>
</div>